import React from 'react';
import { Dropdown, Menu } from 'antd';
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import Button from '../../../../shared/globalStyling/Button';
import { ButtonText } from '../../../../shared/globalStyling/styledText';

import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import JSZip from 'jszip';

const ExportCSVButton = ({ campaignName, generateReport, loadingCampaigns }) => {
  const reports = [
    {
      name: `By Date`,
      reportName: `${campaignName.replace(/[\W_]/g, '_')}-By Date`,
      key: `byDate`,
    },
  ];

  const menu = (
    <Menu>
      {reports.map((report) => {
        return (
          <Menu.Item
            key={report.key}
            onClick={() => {
              try {
                const name = report.reportName;
                const zip = new JSZip();
                const folder = zip.folder(name);
                const fileData = generateReport(report.key);
                folder.file(`${name}.csv`, Papa.unparse(fileData));
                zip.generateAsync({ type: 'blob' }).then(
                  (blob) => {
                    saveAs(blob, name);
                    return true;
                  },
                  function (e) {
                    console.log('error', e);
                    return false;
                  }
                );
              } catch (err) {
                console.log(`CSV error: ${err}`);
              }
            }}
          >
            {report.name}
          </Menu.Item>
        );
      })}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft" disabled={loadingCampaigns}>
      <Button
        style={{ width: '100%' }}
        icon={loadingCampaigns ? <LoadingOutlined /> : <DownloadOutlined />}
        type="primary"
      >
        <ButtonText text={'Export CSV'} />
      </Button>
    </Dropdown>
  );
};

export default ExportCSVButton;
